// How big things on the site plan are on screen: the plan is drawn to fit the
// screen, so a finger's target in plan units changes with the iPad's width and
// which way up it is. Shared by the photo pins and the access lines.
import { useEffect, useState } from 'react';

/** A finger's target on screen (px): nothing on the plan is smaller to touch. */
export const TOUCH_TARGET_PX = 44;

/** How many plan units one screen pixel is, as the plan is drawn now (it changes with the screen's width and turning the iPad). */
export function useUnitsPerPx(svg: React.RefObject<SVGSVGElement | null>, planWidth: number): number {
  const [widthPx, setWidthPx] = useState(0);
  useEffect(() => {
    const el = svg.current;
    if (!el) return;
    const observer = new ResizeObserver(() => setWidthPx(el.getBoundingClientRect().width));
    observer.observe(el);
    return () => observer.disconnect();
  }, [svg]);
  return widthPx > 0 ? planWidth / widthPx : 1;
}
